import { FeaturesConfig } from "availkit-js/dist/Models/Events/FeatureAvailabilityEvent";

import { PresenceServerConsoleFeatures } from "src/services/ApiClient/console";

// Allows to have a single source of truth when looking for a Console feature coming from Presence Server
export const hasConsoleFeature = (
  featureName: keyof PresenceServerConsoleFeatures,
  features: PresenceServerConsoleFeatures | FeaturesConfig
) => features?.hasOwnProperty(featureName);
